import { lazy } from 'react';

const InformationForms = lazy(() =>
	import(
		'@ameroservices-platform/attraction-backend/app/main/apps/frontendSettings/informationForms/informationForms/InformationForms'
	)
);
const InformationForm = lazy(() =>
	import(
		'@ameroservices-platform/attraction-backend/app/main/apps/frontendSettings/informationForms/informationForm/InformationForm'
	)
);

const InformationFormsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/frontend-settings/information-forms',
			element: <InformationForms />
		},
		{
			path: '/apps/frontend-settings/information-forms/:informationFormId',
			element: <InformationForm />
		}
	]
};

export default InformationFormsAppConfig;
